import { isDateRangeValid, isWithin31Day } from '../../../helpers/dateParser';
export const isProjectCodeEmpty = (projectCode) => {
  return projectCode == '' ? true : false;
};
export const isProjectNameEmpty = (projectStatus) => {
  return projectStatus == '' ? true : false;
};
export const checkStatusVariant = (statusId) => {
  switch (statusId) {
    case 1:
      return 'disabled default';
    case 2:
      return 'secondary-info';
    case 3:
      return 'secondary-success';
    case 4:
      return 'secondary-pending';
    case 5:
      return 'disabled default';
    case 6:
      return 'secondary-success';
  }
};
export const isProjectLogsDateRangeValid = (dateFrom, dateTo) => {
  if (!isDateRangeValid(dateFrom, dateTo)) {
    return false;
  } else if (isWithin31Day(dateFrom, dateTo)) {
    return false;
  } else {
    return true;
  }
};
